import { analyticsTrack } from "../utils/analytics";
import { parseStructuredDataJSON } from "../utils/structured-data";
import { logger } from "./logger";

export function install(): void {
  const schemaElements = document.querySelectorAll<HTMLScriptElement>(
    'script[type="application/ld+json"]'
  );

  schemaElements.forEach((schemaElement) => {
    const schema = parseStructuredDataJSON(schemaElement, logger);
    const offer = schema["offers"] || {};
    let imageUrl: string | null = null;

    if (typeof schema["image"] === "string") {
      imageUrl = schema["image"];
    }

    if (typeof offer === "object" && offer && schema["@type"] === "Product") {
      analyticsTrack("Product Viewed", {
        application: "ff8",
        sku: schema["productID"],
        brand: schema["brand"],
        name: schema["name"],
        url: window.location.href,

        image_url: imageUrl?.indexOf("data:") === 0 ? null : imageUrl,
        currency: offer["priceCurrency"],
        price: Number(offer["price"] || 0),
      });
    }
  });
}
